export const APIErrors = {
  Unknown: 0,
  SystemError: 1,
  UserNotFound: 1001,
  InvalidGrant: 1002,
  ValidationPending: 1003,
  RegistrationError: 1004,
  EmailAlreadyTaken: 1005,
  InvalidPassword: 1006,
  InvalidPhoneNumberFormat: 1007,
  InvalidSignInCredentials: 1008,
  InvalidFirstName: 1009,
  InvalidLastName: 1010,
  InvalidEmail: 1011,
  InvalidZipCode: 1012,
  PasswordAndConfirmPasswordNotMatch: 1013,
  InvalidGoogleApiResponseStatusCode: 1014,
  ZipCodeDoesNotExists: 1015,
  TimezoneNotFound: 1016,
  TimezoneNotSupported: 1017,
  InvalidResetPasswordCredentials: 1018,
  CountryNotSupported: 1019,
  IncorrectPassword: 1020,
  UserIsNotBlocked: 1021,
  UserIsAlreadyBlocked: 1022,
  UserIsAlreadyDeleted: 1023,
  InvalidDealershipName: 1024,
  InvalidDealershipAddress: 1025,
  InvalidDealershipCity: 1026,
  InvalidDealershipState: 1027,
  InvalidDealershipZipCode: 1028,
  InvalidDealerUserType: 1029,
  DealerUserInfoNotFound: 1030,
  NotEmptyValidator: 'NotEmptyValidator',

  DesiredPriceLessLienAmount: 'DESIRED_PRICE_LESS_LIEN_AMOUNT',
  DesiredMinimumOfferLessLienAmount: 'DESIRED_MINIMUM_OFFER_LESS_LIEN_AMOUNT',
  BenefitsProgramNotFound: 'BENEFITS_PROGRAM_NOT_FOUND',
  BenefitsProgramIsDisabled: 'BENEFITS_PROGRAM_IS_DISABLED',
  CustomGroupNameExistsInTheMainGroupList: 'CUSTOM_GROUP_NAME_EXISTS_IN_THE_MAIN_GROUP_LIST',
  CustomGroupAbbreviationExistsInTheMainGroupList:
    'CUSTOM_GROUP_ABBREVIATION_EXISTS_IN_THE_MAIN_GROUP_LIST',
  CustomGroupNameExistsInTheCustomGroupList: 'CUSTOM_GROUP_NAME_EXISTS_IN_THE_CUSTOM_GROUP_LIST',
  CustomGroupAbbreviationExistsInTheCustomGroupList:
    'CUSTOM_GROUP_ABBREVIATION_EXISTS_IN_THE_CUSTOM_GROUP_LIST',
}

export const verificationErrors = {
  NOT_FOUND: 0,
  ALREADY_VERIFIED: 1,
  VERIFICATION_ERROR: 2,
  VERIFICATION_NO_MATCH: 3,
}
